module.exports = __webpack_public_path__ + "static/2-befc1ffc20d3d9956362929504433c98.png";